<template>
  <div class="cursor-pointer" @click="showInteractive = true">
    <div v-if="showInteractive" ref="map" class="size-full" />
    <VenueStaticMap v-else :venue="venue" />
  </div>
</template>

<script>
import { useRuntimeConfig } from 'nuxt/app'
import VenueStaticMap from '~/components/venue/VenueStaticMap'

const markerActive = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="250 250 360 360"><defs><clipPath id="clip-path"><rect class="cls-1" x="300.02" y="255.11" width="267.27" height="354.88"/></clipPath></defs><g id="Layer_3" data-name="Layer 3"><g class="cls-2"><path class="cls-3" d="M433.66,269.56c-65.7,0-119.19,53.65-119.19,119.56,0,83.45,74.67,166.26,111.51,203.22a10.82,10.82,0,0,0,15.33,0l0,0c36.85-37,111.52-119.77,111.52-203.22,0-65.91-53.49-119.56-119.19-119.56"/><path class="cls-4" d="M433.66,610h0a25.12,25.12,0,0,1-17.89-7.46C363,549.58,300,469.57,300,389.12c0-73.9,60-134,133.64-134s133.64,60.11,133.64,134c0,80.31-62.72,160.19-115.46,213.15l-.31.32A25.13,25.13,0,0,1,433.66,610Zm0-326c-57.76,0-104.74,47.15-104.74,105.11,0,38.57,18.26,102.81,104.74,190.44C520.14,491.93,538.4,427.7,538.4,389.12,538.4,331.16,491.41,284,433.66,284Z"/></g></g></svg>'
let mapboxgl

export default {
  components: { VenueStaticMap },

  props: {
    venue: { type: Object, required: true },
  },

  data: () => {
    return {
      mapStyle: 'mapbox://styles/tripexpertweb/ckcdpjifn06ru1impw321xsqi',
      map: null,
      markers: [],
      showInteractive: false,
    }
  },

  watch: {
    showInteractive (val) {
      if (val) {
        setTimeout(() => this.initMap(), 50)
      }
    },
  },

  methods: {
    async initMap () {
      mapboxgl = (await import('mapbox-gl')).default
      mapboxgl.accessToken = useRuntimeConfig().public.mapboxApiToken
      this.map = new mapboxgl.Map({
        container: this.$refs.map,
        style: 'mapbox://styles/tripexpertweb/ckcdpjifn06ru1impw321xsqi',
        center: [this.venue.longitude, this.venue.latitude],
        zoom: 14,
      })
      this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left')
      this.addMarker()
    },

    addMarker () {
      // create DOM element for the marker
      const el = document.createElement('div')
      el.innerHTML = `<div class="marker-inner">${markerActive}</div>`
      el.id = `marker-${this.venue.id}`
      el.className = 'marker acttive'

      const marker = new mapboxgl.Marker(el)
        .setLngLat([this.venue.longitude, this.venue.latitude])
        .addTo(this.map)

      this.markers.push(marker)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .marker {
    @apply w-12 h-12 font-medium text-body text-center cursor-pointer;
    font-size: 22px; margin-top: -24px; line-height: 30px;

    .cls-1 { fill: none; }
    .cls-2 { clip-path: url(#clip-path); }
    .cls-3 { fill: #d9f505; }
    .cls-4 { fill: #000000; }
  }
  .mapboxgl-ctrl-top-left .mapboxgl-ctrl {
    @apply mt-3;
  }
}
</style>
